








import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import {CountryEnum, CountryType} from '@/enums/country.enum';

@Component({
  name: 'PbiAfterSalesPage',
  components: { ReportPowerBiContainer }
})
export default class PbiAfterSalesPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.GM, CountryEnum.Brasil], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'a6a2b00d-567c-430a-9a24-d535f0db7f2e' });
    this.dictReports.set([ClientEnum.Volkswagen, CountryEnum.Brasil], { brand: 'VW', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'aeb03cd4-c9d2-4f2e-83db-b90b96dd0e0c' });

    this.dictReports.set([ClientEnum.GM, CountryEnum.Colombia], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '166a00a4-9cee-4d15-a2e6-f3479cdb37ff' });
    this.dictReports.set([ClientEnum.GM, CountryEnum.Peru], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '6711b7c8-5d40-4241-ab43-c54e573f4659' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - After Sales Report`);
  }
}
